import { Link } from "react-router-dom"
import useIsMobile from "../hooks/useIsMobile"

export default function QuizCard({ quiz }) {
    const isMobile = useIsMobile()

    const cardStyle = {
        border: "1px solid #E5E7EB",
        borderRadius: 20,
        padding: isMobile ? 24 : 40,
        boxShadow: "0 10px 30px rgba(17,24,39,0.05)",
        background: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    }

    const meta = [
        quiz.questions && `${quiz.questions} questions`,
        quiz.badge,
    ].filter(Boolean)

    return (
        <div style={cardStyle}>
            <div>
                <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
                    <span style={{
                        background: quiz.categoryColor.bg,
                        color: quiz.categoryColor.text,
                        borderRadius: 8, padding: "4px 12px",
                        fontSize: 13, fontWeight: 700,
                    }}>
                        {quiz.category}
                    </span>
                    <span style={{
                        background: quiz.difficultyColor.bg,
                        color: quiz.difficultyColor.text,
                        borderRadius: 8, padding: "4px 12px",
                        fontSize: 13, fontWeight: 600,
                    }}>
                        {quiz.difficulty}
                    </span>
                </div>

                <h3 style={{ fontSize: isMobile ? 22 : 32, lineHeight: 1.2, margin: "0 0 12px" }}>
                    {quiz.title}
                </h3>

                <p style={{ color: "#6B7280", lineHeight: 1.8, fontSize: isMobile ? 15 : 17, margin: 0 }}>
                    {quiz.description}
                </p>
            </div>

            <div style={{ marginTop: 28 }}>
                <div style={{ display: "flex", gap: 12, fontSize: 14, color: "#9CA3AF", marginBottom: 16, flexWrap: "wrap" }}>
                    {meta.map((item, i) => (
                        <span key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            {i > 0 && <span>·</span>}
                            {item}
                        </span>
                    ))}
                </div>

                {quiz.isPaid ? (
                    <>
                    <div style={{ display: "flex", gap: 10 }}>
                        <Link
                            to={quiz.sampleLink}
                            onClick={() => {
                                if (typeof window.gtag === "function") {
                                    window.gtag("event", "quiz_cta_clicked", {
                                        quiz_id:    quiz.id,
                                        quiz_title: quiz.title,
                                    })
                                }
                            }}
                            style={{
                                flex: 2, display: "flex", alignItems: "center", justifyContent: "center",
                                background: "#2563EB", color: "white",
                                padding: "12px 16px", borderRadius: 12,
                                textDecoration: "none", fontWeight: 700, fontSize: 15,
                            }}
                        >
                            Start Quiz →
                        </Link>
                        <span style={{
                            display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                            flex: 1,
                            background: "#FDF4FF", color: "#7C3AED",
                            padding: "12px 10px", borderRadius: 12,
                            fontSize: 14, fontWeight: 700,
                            border: "1px solid #E9D5FF",
                            whiteSpace: "nowrap",
                        }}>
                            🔒 {quiz.price || "Premium"}
                        </span>
                    </div>
                    <p style={{ fontSize: 12, color: "#9CA3AF", margin: "8px 0 0", textAlign: "center" }}>
                        Buy on Stripe → receive access code by email → enter it to unlock
                    </p>
                    </>
                ) : (
                    <Link
                        to={quiz.sampleLink}
                        onClick={() => {
                            if (typeof window.gtag === "function") {
                                window.gtag("event", "quiz_cta_clicked", {
                                    quiz_id:    quiz.id,
                                    quiz_title: quiz.title,
                                    quiz_type:  "free",
                                })
                            }
                        }}
                        style={{
                            display: "block", textAlign: "center",
                            background: "#2563EB", color: "white",
                            padding: "12px 0", borderRadius: 12,
                            textDecoration: "none", fontWeight: 700, fontSize: 15,
                        }}
                    >
                        Start Free Quiz →
                    </Link>
                )}
            </div>
        </div>
    )
}
